/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.7.1",
    versionName: "0.2.0-nightly.2025.7.1",
    versionChannel: "nightly",
    buildDate: "2025-07-01T00:09:53.134Z",
    commitHash: "200a3e50b59edb223499b38b9707b0e4e981c06f",
};
